'use strict';

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var EventEmitter = require('events');

var pipe = require('it-pipe');

var PROTOCOL = require('./protocol');

var encoding = require('./encoding');

module.exports = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Connection, _EventEmitter);

  var _super = _createSuper(Connection);

  function Connection(remoteId, libp2p, room) {
    var _this;

    _classCallCheck(this, Connection);

    _this = _super.call(this);
    _this._remoteId = remoteId;
    _this._libp2p = libp2p;
    _this._room = room;
    _this._connection = null;
    _this._connecting = false;
    return _this;
  }

  _createClass(Connection, [{
    key: "push",
    value: function push(message) {
      var _this2 = this;

      if (this._connection) {
        this._connection.push(encoding(message));

        return;
      }

      this.once('connect', function () {
        _this2.push(message);
      });

      if (!this._connecting) {
        this._connect();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._connection) {
        this._connection.end();
      }
    }
  }, {
    key: "_connect",
    value: function () {
      var _connect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var peerInfo, _yield$this$_libp2p$d, stream;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._connecting = true;

                if (this._isConnectedToRemote()) {
                  _context2.next = 5;
                  break;
                }

                this.emit('disconnect');
                this._connecting = false;
                return _context2.abrupt("return");

              case 5:
                peerInfo = this._libp2p.peerStore.get(this._remoteId);
                _context2.next = 8;
                return this._libp2p.dialProtocol(peerInfo, PROTOCOL);

              case 8:
                _yield$this$_libp2p$d = _context2.sent;
                stream = _yield$this$_libp2p$d.stream;
                this._connection = new FiFoMessageQueue();
                pipe(this._connection, stream, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, message;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this3._connecting = false;

                            _this3.emit('connect', _this3._connection);

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _context.prev = 4;
                            _iterator = _asyncIterator(source);

                          case 6:
                            _context.next = 8;
                            return _iterator.next();

                          case 8:
                            _step = _context.sent;
                            _iteratorNormalCompletion = _step.done;
                            _context.next = 12;
                            return _step.value;

                          case 12:
                            _value = _context.sent;

                            if (_iteratorNormalCompletion) {
                              _context.next = 19;
                              break;
                            }

                            message = _value;

                            _this3.emit('message', message);

                          case 16:
                            _iteratorNormalCompletion = true;
                            _context.next = 6;
                            break;

                          case 19:
                            _context.next = 25;
                            break;

                          case 21:
                            _context.prev = 21;
                            _context.t0 = _context["catch"](4);
                            _didIteratorError = true;
                            _iteratorError = _context.t0;

                          case 25:
                            _context.prev = 25;
                            _context.prev = 26;

                            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                              _context.next = 30;
                              break;
                            }

                            _context.next = 30;
                            return _iterator.return();

                          case 30:
                            _context.prev = 30;

                            if (!_didIteratorError) {
                              _context.next = 33;
                              break;
                            }

                            throw _iteratorError;

                          case 33:
                            return _context.finish(30);

                          case 34:
                            return _context.finish(25);

                          case 35:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[4, 21, 25, 35], [26,, 30, 34]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).then(function () {
                  _this3.emit('disconnect');
                }, function (err) {
                  _this3.emit('error', err);
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _connect() {
        return _connect2.apply(this, arguments);
      }

      return _connect;
    }()
  }, {
    key: "_isConnectedToRemote",
    value: function _isConnectedToRemote() {
      var _iterator2 = _createForOfIteratorHelper(this._libp2p.connections.keys()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var peerId = _step2.value;

          if (peerId === this._remoteId) {
            return true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return Connection;
}(EventEmitter);

var FiFoMessageQueue = /*#__PURE__*/function () {
  function FiFoMessageQueue() {
    _classCallCheck(this, FiFoMessageQueue);

    this._queue = [];
  }

  _createClass(FiFoMessageQueue, [{
    key: Symbol.asyncIterator,
    value: function value() {
      return this;
    }
  }, {
    key: "push",
    value: function push(message) {
      if (this._ended) {
        throw new Error('Message queue ended');
      }

      if (this._resolve) {
        return this._resolve({
          done: false,
          value: message
        });
      }

      this._queue.push(message);
    }
  }, {
    key: "end",
    value: function end() {
      this._ended = true;

      if (this._resolve) {
        this._resolve({
          done: true
        });
      }
    }
  }, {
    key: "next",
    value: function next() {
      var _this4 = this;

      if (this._ended) {
        return {
          done: true
        };
      }

      if (this._queue.length) {
        return {
          done: false,
          value: this._queue.shift()
        };
      }

      return new Promise(function (resolve) {
        _this4._resolve = resolve;
      });
    }
  }]);

  return FiFoMessageQueue;
}();